import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import './element-#003950/index.css';
import axios from "axios";

//import 'element-ui/lib/element-#003950/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import VueDraggableResizable from 'vue-draggable-resizable'
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from './store/store.js';


Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.component('vue-draggable-resizable', VueDraggableResizable)


import Trend from "vuetrend"

Vue.use(Trend)

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))


var gaussian = require('gaussian');
import VueDragResize from 'vue-drag-resize'
Vue.component('VueDragResize', VueDragResize)

import vuetify from 'vuetify'
Vue.use(vuetify)


// import TrendChart from "vue-trend-chart";
//
// Vue.use(TrendChart);

new Vue({
  store,
  router,
  // data: {
  //   message: 'Hello World!',
  //   startyear: 2020,
  //   endyear: 2025
  // },
  data: function () {
    return {
      message: 'Hello World!',
      startyear: 2020,
      endyear: 2025
    }
  },
  beforeCreate: function() {
      //this.$store.dispatch("init");
      console.log("hello, I should be first")

      console.log("nCols updated in mounted")

      var colWidth = JSON.parse(JSON.stringify(this.$store.state.colWidth));
      var startyear = JSON.parse(JSON.stringify(this.$store.state.startyear));
      var endyear = JSON.parse(JSON.stringify(this.$store.state.endyear));


      function numberOfDays(year, month) {
          var d = new Date(year, month+1,0);
          // console.log(d)
          return d.getDate();
      }
      function days_of_a_year(year) {

        return isLeapYear(year) ? 366 : 365;
      }

      function isLeapYear(year) {
           return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
      }

      var years = []
      var months = []
      var days = []
      var yend = 0;
      var ystart = 1;

      var mstart = 0;
      var mend = 0;

      var dstart = 1;
      var dend = 0;

      console.log("startyear",startyear,"endyear",endyear)
      for(let y=startyear; y<=endyear; y++){

        for(let m=0; m<12; m++){

          for(let d=1; d<(numberOfDays(y, m)+1); d++){
            yend++;
            mend++;
            dend++;
            if(y==startyear&&m==0&&d==1){
              days.push({day:d, start: 1, end:dend*colWidth})
              dstart = dend+0;
            }else{
              days.push({day:d, start: dstart*colWidth, end:dend*colWidth})
              dstart = dend+0;
            }

          }

          if(y==startyear&&m==0){
            months.push({month: m, start:1, end:mend*colWidth})
            mstart = mend+0;
          }else{
            months.push({month: m, start:mstart*colWidth, end:mend*colWidth})
            mstart = mend+0;
          }

        }

        if(y==startyear){
          years.push({year: y, start:1, end:yend*colWidth })
          ystart = yend+0;

        }else{
          years.push({year: y, start:ystart*colWidth, end:yend*colWidth })
          ystart = yend+0;
        }


      }

      var getDaysArray = function(start, end) {
          for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
              arr.push(new Date(dt));
          }
          return arr;
      };

      var daylist = getDaysArray(new Date(startyear,0,1),new Date(endyear,11,1));
      console.log("daylist",daylist)

      var FirstOfMonth=[]
      for(let d=0; d<daylist.length; d++){
        if(daylist[d].getDate()==1){
          FirstOfMonth.push(daylist[d])
        }
      }
      console.log("FirstOfMonth",FirstOfMonth,FirstOfMonth)
      this.$store.dispatch('updateDateIndex',[daylist,years,months,days,FirstOfMonth])
      // var DateIndexclone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      this.$store.dispatch('BuildOutputBlocks',1)

      this.$store.dispatch('UpdateOutputBlocks',"all")


    },
  render: h => h(App)
}).$mount('#app')
